import { writable } from "svelte/store";
import { authUrl, baseUrl, protocol } from "./const";

export const roleMap = {
	"obs": "Observer",
	"admin": "Admin",
	"con": "Contributor",
	"fo": "Flight Operator"
}

let TOKEN;
let tokenExp;

const { subscribe, set } = writable({});

let getTokenPromise;
async function getToken() {
	if (!getTokenPromise) {
		getTokenPromise = getTokenInternal();
	}
	try {
		return await getTokenPromise;
	} finally {
		getTokenPromise = null;
	}
}

export async function logout() {
	try {		
		const auth_url = `${protocol}//${authUrl}/logout`;
		await fetch(auth_url, {
			method: "POST",
			credentials: "include",
		});
		TOKEN = null
		await getToken()
	} catch (error) {
		console.error(error)
		// set({	error	})
	}
}

async function getTokenInternal() {
	if (TOKEN && tokenExp && tokenExp > Date.now() / 1000) {
		return TOKEN;
	}
	tokenExp = null;

	try {		
		const auth_url = `${protocol}//${authUrl}/login/token`;
		const token_req = await fetch(auth_url, {
			method: "GET",
			credentials: "include",
		});
		if (!token_req.ok) {
			set({
				loginRedir:window.location.href
			})
			window.location = `${protocol}//${authUrl}/login?d=${window.location.hostname}&r=${window.location.href}`
			return
		}
		
		const bearer_info = await token_req.json();
		if (!bearer_info.token) {
			throw new Error("No token");
		}
		
		const validate_url = `${protocol}//${baseUrl}/auth/validate`;
		const validate_req = await fetch(validate_url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${bearer_info.token}`,
			},
			body: JSON.stringify(bearer_info),
		});
		if (!validate_req.ok) {
			throw new Error("Could not validate the token");
		}
		
		TOKEN = bearer_info.token;
		let userInfo;
		try {
			userInfo = jwtDecode(TOKEN);
			tokenExp = userInfo.exp;
		} catch (error) {
			console.error("Could not parse JWT", error);
		}
		set({
			token: TOKEN,
			username: userInfo.displayName,
			roles: getRoles(),
			userInfo
		});
		return TOKEN;
	} catch (error) {
		console.error(error)
		set({	error	})
	}
}

export const auth = {
	subscribe,
	getToken,
};

function getRoles() {
	try {
		const userInfo = jwtDecode(TOKEN);
		return userInfo?.roles ?? []
	} catch (error) {
		console.error("Could not parse JWT", error);
		return {};
	}
}

function jwtDecode(token) {
	// https://stackoverflow.com/a/38552302/243953
	var base64Url = token.split(".")[1];
	var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	var jsonPayload = decodeURIComponent(
		atob(base64)
			.split("")
			.map(function (c) {
				return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join("")
	);

	return JSON.parse(jsonPayload);
}

export function hasRole(auth, role) {
	if (!auth || !auth.userInfo) return false
	return (auth.userInfo.roles.includes(role) || auth.userInfo.roles.includes('admin'))
}

export function userRoleNames(roles) {
	if (!roles) return ''
	return roles.map(r=>roleMap[r]).sort().join(', ')
}